import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AmbientStatement from './components/AmbientStatement';
import FeatureMeasure from './components/FeatureMeasure';
import FeatureMap from './components/FeatureMap';
import StatsConcert from './components/StatsConcert';
import FeatureCommunity from './components/FeatureCommunity';
import FeatureDashboard from './components/FeatureDashboard';
import HealthSection from './components/HealthSection';
import PhoneMockup from './components/PhoneMockup';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';

import imgAmbient1 from './assets/9.jpg';
import imgAmbient2 from './assets/11.jpg';

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <AmbientStatement 
        bgImage={imgAmbient1} 
        text="Noise is everywhere."
      />
      <AmbientStatement 
        bgImage={imgAmbient2}
        text="Listen to your world."
        textSize="medium"
        overlayOpacity={0.75}
        parallaxSpeed={0.4}
      />
      <FeatureMeasure />
      <HealthSection />
      <StatsConcert />
      <FeatureDashboard />
      <FeatureMap />
      <FeatureCommunity />
      <PhoneMockup />
      <CtaSection />
      <Footer />
    </>
  );
}

export default App;
